import React from "react";
import { INTRODUCING } from "../mock";
import { Eyebrow } from "./Hero";

export default function Introducing() {
  return (
    <section id="about" data-testid="protocol-section" className="relative py-14 md:py-16 sep-top">
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <div className="mb-5 text-center md:mb-8">
          <Eyebrow text={INTRODUCING.eyebrow} testId="introducing-eyebrow" />
        </div>
        <div className="mx-auto grid max-w-5xl items-center gap-6 md:grid-cols-[minmax(260px,0.9fr)_minmax(0,1.1fr)] md:gap-8 xl:max-w-[1056px] xl:translate-x-4 xl:grid-cols-[460px_540px] xl:gap-14">
          <div className="flex justify-center">
            <img src="/eazybot-mascot.png" alt="EazyBot robot mascot" data-testid="introducing-mascot" className="w-full max-w-[300px] object-contain sm:max-w-[345px] md:max-w-[390px]" />
          </div>
          <div className="text-center md:-translate-y-3 md:text-left">
            <h2 className="font-display text-center text-3xl leading-[1.05] md:relative md:-top-[22px] md:text-[2.5rem]" data-testid="introducing-heading" style={{ color: "#201850" }}>{INTRODUCING.heading}</h2>
            <div className="introducing-copy responsive-copy mt-5 space-y-5 text-base md:text-[1.2rem]" style={{ lineHeight: 1.65, color: "rgba(32,24,80,0.9)" }}>
              {INTRODUCING.paragraphs.map((p, i) => <p key={i} data-testid={`protocol-body-${i + 1}`}>{p}</p>)}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
